export default __webpack_public_path__ + "static/media/36I-102698_-15666_0.6235cb07.jpg";